import classNames from 'classnames';

import { ChevronDownIcon } from '@air/design-icons';

export type RotatingDowntickProps = {
  rotate: boolean;
};

/**
 * This is used in the side boards tree to open and close boards lists
 */
export const RotatingDowntick = ({ rotate }: RotatingDowntickProps) => {
  return (
    <ChevronDownIcon
      className={classNames(
        'flex h-4 w-4 items-center justify-center ads:text-icon-subtle text-gray-9 transition-transform',
        rotate && '-rotate-90',
      )}
    />
  );
};
